import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'ContentCardDefault';

  static fields = {
    id: attr(),
    value: attr(),
    description: attr(),
    sort: attr(),
    type: attr(),
    name: attr(),
    isHidden: attr(),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'contentCardDefaults',
    }),
  };

  static reducer({ type, payload }, ContentCardDefault) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        ContentCardDefault.all().delete();

        if (payload.contentCardDefaults) {
          payload.contentCardDefaults.forEach((contentCardDefault) => {
            ContentCardDefault.upsert(contentCardDefault);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.contentCardDefaults) {
          payload.contentCardDefaults.forEach((contentCardDefault) => {
            ContentCardDefault.upsert(contentCardDefault);
          });
        }

        break;
      case ActionTypes.CONTENT_CARD_DEFAULTS_FETCH__SUCCESS: {
        const targetPointSystemId = String(payload.pointSystemId);
        ContentCardDefault.all()
          .toModelArray()
          .filter((item) => String(item.pointSistemId) === targetPointSystemId)
          .forEach((item) => item.delete());
        payload.items.forEach((item) => {
          ContentCardDefault.upsert(item);
        });

        break;
      }
      case ActionTypes.CONTENT_CARD_DEFAULT_CREATE__SUCCESS:
      case ActionTypes.CONTENT_CARD_DEFAULT_UPDATE__SUCCESS:
      case ActionTypes.CONTENT_CARD_DEFAULT_DELETE__SUCCESS:
        ContentCardDefault.upsert(payload.item);

        break;
      case ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS: {
        const targetPointSystemId = String(payload.pointSystemId);
        ContentCardDefault.all()
          .toModelArray()
          .filter((item) => String(item.pointSistemId) === targetPointSystemId)
          .forEach((item) => item.delete());
        (payload.contentCardDefaults || []).forEach((item) => {
          ContentCardDefault.upsert(item);
        });

        break;
      }
      default:
    }
  }
}

